<template lang="pug">
    Modal
        .form
            h2 Create a New Product
            .form__control-group
                label Name
                input(
                    v-model="name"
                    type="text"
                    placeholder="Name"
                )
            .form__control-group.rule__control-group--select(
                v-if="getMarkets.length > 1"
            )
                label Default Market
                select.form__select(
                    v-model="market"
                )
                    option(
                        value=""
                        disabled
                        selected
                    ) Select Market
                    option(
                        :key="market.name"
                        v-for="(market, index) in getMarkets"
                        :value="market"
                    ) {{market.title}} - {{market.primaryLanguage}}
            button.button__submit(
                @click="submit"
            ) Create
            p.validation__error(
                v-if="showError"
            ) Please enter a Name and Default Market.
</template>
<script>
import Modal from '../general/Modal';
import store from '../../store';
import { postResource } from '../../services/Utils';
import Services from '../../services/Services';
import VueNotifications from 'vue-notifications';
export default {
  name: 'CreateProduct',
  components: {
    Modal
  },
  computed: {
    getCardTypes() {
      if (store.getters.getCardTypes.length) {
        return store.getters.getCardTypes;
      } else {
        Services.getCardTypes();
        return store.getters.getCardTypes;
      }
    },
    getMarkets() {
      return store.getters.getMarkets;
    }
  },
  data() {
    return {
      name: '',
      market: '',
      showError: false
    };
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  methods: {
    submit() {
      if (!this.name || !this.market) {
        this.showError = true;
        return false;
      }
      let newProduct = {};

      newProduct.name = this.name;
      newProduct.markets = this.market._id;

      newProduct.fallbackLocale = this.market.locale;

      postResource('/v1/products/create', false, newProduct)
        .then(res => {
          console.log('success!', res);
          this.showSuccessMsg({ message: `${this.name} product created!` });
          store.commit('hideModals', true);
          this.$router.push(`/products/${res.product._id}`);
          return res;
        })
        .catch(error => {
          let message = 'An error occurred. Please try again.';
          if (error.message) {
            message = error.message;
          }
          this.showErrorMsg({
            message
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.form {
  padding: 2rem;
  display: flex;
  // align-items: center;
  justify-content: center;
  flex-direction: column;

  h2 {
    text-align: center;
    width: 100%;
  }

  .form__control-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    width: 100%;

    label {
      margin-bottom: 5px;
    }

    &:after {
      top: 20px !important;
    }

    input {
      padding-left: 0.5rem;
      height: 40px;
    }

    select,
    option {
      text-transform: capitalize;
    }
  }
}
</style>






// WEBPACK FOOTER //
// src/components/modals/CreateProduct.vue